import { StyleSheet, View, Text } from "react-native";
import { timeValue, getSchemeStyle } from "../context/helper";
import RSSIImage from "./RSSIImage";

const SensorBranchSubitem = (props) => {
  const schemeStyles = getSchemeStyle();

  let mdata = props.item;

  const tempValue = () => {
    return props.item.value == -99 ? "---" : props.item.value + props.item.unit;
  };

  const voltageValue = () => {
    return props.item.voltage > 0.5 ? props.item.voltage + "V" : "";
  };

  const rssiValue = () => {
    return props.item.rssi == 0 ? "---" : props.item.rssi + "dBm";
  };

  return (
    <View key={mdata.id} style={[styles.itemContainer, schemeStyles.Border]}>
      <Text
        style={[
          styles.nameText,
          schemeStyles.defaultText,
          mdata.errordata.interval && schemeStyles.errorText,
        ]}
      >
        {timeValue(props.item.time)}
      </Text>
      <Text
        style={[
          styles.infoText,
          styles.tempText,
          schemeStyles.defaultText,
          mdata.errordata.temperature && schemeStyles.errorText,
        ]}
      >
        {tempValue()}
      </Text>
      <Text
        style={[
          styles.infoText,
          schemeStyles.defaultText,
          mdata.errordata.voltage && schemeStyles.errorText,
        ]}
      >
        {voltageValue()}
      </Text>
      <View style={styles.rssiContainer}>
        <Text style={[styles.infoText, schemeStyles.defaultText]}>
          {rssiValue()}
        </Text>
        <RSSIImage
          style={{ marginLeft: 5 }}
          size={18}
          rssi={props.item.rssi}
          goodColor={schemeStyles.rssiImage.goodColor}
          weakColor={schemeStyles.rssiImage.weakColor}
          badColor={schemeStyles.rssiImage.badColor}
          doincrease={schemeStyles.rssiImage.doincrease}
        />
      </View>
    </View>
  );
};

export default SensorBranchSubitem;

const styles = StyleSheet.create({
  itemContainer: {
    flexDirection: "row",
    marginBottom: 5,
    padding: 3,
    borderTopWidth: 1,
  },
  mainSection: {
    flex: 11,
    marginLeft: 5,
  },
  tempSection: {
    flex: 3,
    marginRight: 10,
    alignItems: "center",
    flexDirection: "row",
  },
  infoSection: { flex: 3 },
  nameText: {
    flex: 5,
    fontFamily: "Roboto-Regular",
  },
  infoText: {
    fontFamily: "Roboto-Regular",
    textAlign: "right",
    width: 50,
    flex: 2,
  },
  tempText: {
    fontFamily: "Roboto-Bold",
    flex: 2,
  },
  rssiContainer: {
    flexDirection: "row",
    marginLeft: 10,
    flex: 3,
  },
});
